import {
  Animation,
  type AnimationOptions,
  type BackgroundColorOptions,
  StatusBar as CapacitorStatusBar,
  type SetOverlaysWebViewOptions,
  Style,
  type StyleOptions,
} from "@capacitor/status-bar";

export const StatusBar = (function () {
  async function setStyle(style: StyleOptions["style"] = Style.Default) {
    return await CapacitorStatusBar.setStyle({ style });
  }

  // Instance of bg-surface-neutral in tailwind.config.ts
  async function setBackgroundColor(color: BackgroundColorOptions["color"] = "#ffffff") {
    return await CapacitorStatusBar.setBackgroundColor({ color });
  }

  async function show(animation?: AnimationOptions["animation"]) {
    return await CapacitorStatusBar.show(animation ? { animation } : undefined);
  }

  async function hide(animation?: AnimationOptions["animation"]) {
    return await CapacitorStatusBar.hide(animation ? { animation } : undefined);
  }

  async function getInfo() {
    return await CapacitorStatusBar.getInfo();
  }

  async function setOverlaysWebView(overlay: SetOverlaysWebViewOptions["overlay"] = true) {
    return await CapacitorStatusBar.setOverlaysWebView({ overlay });
  }

  return {
    ...CapacitorStatusBar,
    Style,
    setStyle,
    setBackgroundColor,
    Animation,
    show,
    hide,
    getInfo,
    setOverlaysWebView,
  };
})();

export type * from "@capacitor/status-bar";
